var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatNumorder = function SvgChatNumorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2917 14.6666H4.12503V15.125H3.20837V16.0416H4.12503V16.5H2.2917V17.4166H5.0417V13.75H2.2917V14.6666ZM3.20837 8.24998H4.12503V4.58331H2.2917V5.49998H3.20837V8.24998ZM2.2917 10.0833H3.9417L2.2917 12.0083V12.8333H5.0417V11.9166H3.3917L5.0417 9.99165V9.16665H2.2917V10.0833ZM6.87503 5.49998V7.33331H19.7084V5.49998H6.87503ZM6.87503 16.5H19.7084V14.6666H6.87503V16.5ZM6.87503 11.9166H19.7084V10.0833H6.87503V11.9166Z",
    fill: "#8F97B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatNumorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_numorder.1a928426.svg";
export { ForwardRef as ReactComponent };